import { render, staticRenderFns } from "./UserEditSubPage.vue?vue&type=template&id=483f8e30&scoped=true&"
import script from "./UserEditSubPage.vue?vue&type=script&lang=js&"
export * from "./UserEditSubPage.vue?vue&type=script&lang=js&"
import style0 from "./UserEditSubPage.vue?vue&type=style&index=0&id=483f8e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f8e30",
  null
  
)

/* custom blocks */
import block0 from "./UserEditSubPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('483f8e30')) {
      api.createRecord('483f8e30', component.options)
    } else {
      api.reload('483f8e30', component.options)
    }
    module.hot.accept("./UserEditSubPage.vue?vue&type=template&id=483f8e30&scoped=true&", function () {
      api.rerender('483f8e30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user-management/UserEditSubPage.vue"
export default component.exports